<template>
  <div class="tabs-wrapper">
    <b-tabs lazy>
      <b-tab title="Products">
        <ulu-devices-sold-details-chart />
      </b-tab>
      <b-tab title="Agents">
        <ulu-devices-sold-details-agents-chart />
      </b-tab>
      <b-tab title="Order 1st/Other">
        <ulu-devices-sold-details-new-chart />
      </b-tab>
      <b-tab title="Comparing">
        <ulu-devices-sold-years-chart />
      </b-tab>
      <b-tab title="Cumulative">
        <ulu-devices-sold-years-cumulative-chart />
      </b-tab>
      <b-tab title="Terminations">
        <ulu-devices-termination-stats />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
export default {
  components: {
    "ulu-devices-sold-details-chart": () =>
      import("@/components/dashboard/devices/DevicesSoldDetailsChart"),
    "ulu-devices-sold-details-agents-chart": () =>
      import("@/components/dashboard/devices/DevicesSoldDetailsAgentsChart"),
    "ulu-devices-sold-details-new-chart": () =>
      import("@/components/dashboard/devices/DevicesSoldDetailsNewChart"),
    "ulu-devices-sold-years-chart": () =>
      import("@/components/dashboard/devices/DevicesSoldYearsChart"),
    "ulu-devices-sold-years-cumulative-chart": () =>
      import("@/components/dashboard/devices/DevicesSoldYearsCumulativeChart"),
    "ulu-devices-termination-stats": () =>
      import("@/components/dashboard/devices/DevicesTerminationStats"),
  }
};
</script>

<style scoped>
.tabs-wrapper >>> .nav-tabs {
  border-bottom: 1px solid #e0e0e0;
  background-color: white;
  padding: 0;
  margin-bottom: 0;
}

.tabs-wrapper >>> .nav-tabs .nav-link {
  border: none;
  border-bottom: 3px solid transparent;
  color: #6c757d;
  font-size: 0.9375rem;
  font-weight: 500;
  padding: 1rem 1.5rem;
  background-color: transparent;
  transition: all 0.2s;
}

.tabs-wrapper >>> .nav-tabs .nav-link:hover {
  border-bottom-color: #ff6b35;
  color: #495057;
}

.tabs-wrapper >>> .nav-tabs .nav-link.active {
  color: #ff6b35;
  border-bottom-color: #ff6b35;
  background-color: white;
  font-weight: 600;
}

.tabs-wrapper >>> .tab-content {
  background-color: white;
  border: none;
  padding: 24px;
}

@media (max-width: 768px) {
  .tabs-wrapper >>> .nav-tabs .nav-link {
    padding: 0.75rem 1rem;
    font-size: 0.875rem;
  }

  .tabs-wrapper >>> .tab-content {
    padding: 16px;
  }
}
</style>
